import {ViewColumn} from "./ViewColumn";
import Filter from "./Filter";

export class WorkspaceView {
	constructor(
		public readonly id: string,
		public readonly name: string,
		public readonly columns: ViewColumn[],
		public readonly filters: Filter[],
		public readonly global: boolean) { }

	copy({name = this.name, columns = this.columns, filters = this.filters, global = this.global}): WorkspaceView {
		return new WorkspaceView(this.id, name, columns, filters, global);
	}
}

